module.exports = __webpack_public_path__ + "img/DJI_0033.ded5c648.jpg";